import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.DocSearchController;
const getController = self.customSetting.getDocSearch;
const postController = self.customSetting.postDocSearch;

export default {
  // 3-2
  docSearchQryPrjCondition: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPrjCondition`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  docSearchQryProjectList: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryProjectList?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  docSearchQryDailyList: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryDailyList?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  docSearchUpdCancelData: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdCancelData`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  docSearchQryUrgentList: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryUrgentList?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  docSearchUpdUrgentCancelData: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/UpdUrgentCancelData`, obj)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  docSearchQrySpecailList: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QrySpecialList?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getViewSpecailSignOffDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getController}/DocSpecialSignOffDetail?prjNo=${prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getPrintSpecialFormInfo: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/DocSpecialPrint?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
